module.exports = __webpack_public_path__ + "img/tooltip_02-VALLONE_MURALE_EDGE_SOLO_C00822_LINO_B.99d6356c.jpg";